// staleChunkReload.ts
const RELOAD_FLAG = '__silent_reload_once__';
const RELOAD_COOL_DOWN_MS = 30000; // avoid rapid loops

function isStaleChunk(err) {
  const msg = String(err?.message || '');
  const name = err?.name;
  return (
    name === 'ChunkLoadError' ||
    /Loading (CSS )?chunk [\w-]+ failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /import\(\) failed/i.test(msg)
  );
}

function recentReload() {
  const last = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
  return Date.now() - last < RELOAD_COOL_DOWN_MS;
}

function markReload() {
  sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
}

function safeReload() {
  if (navigator.onLine && !recentReload()) {
    markReload();
    window.location.reload(); // silent refresh
  }
}

// Handle dynamic import / chunk 404s from router navigation etc.
window.addEventListener('unhandledrejection', (e) => {
  if (isStaleChunk(e.reason)) safeReload();
});

// Some bundlers surface as 'error' instead of 'unhandledrejection'
window.addEventListener(
  'error',
  (e) => {
    if (isStaleChunk(e?.error)) safeReload();
  },
  true
);
